/**
 * Created by Andrey Gayvoronsky on 13/04/16.
 */
const locale = {
  placeholder: 'Выберите время',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/ru_RU.tsx